/* global FormData */
import React, { useState, useEffect } from 'react'
import cn from 'classnames'
import DataProvider from '../../../../utils/provider'
import { DropZone } from '../../../../ui'
import { replace } from 'ramda'
import { useTranslation } from 'react-i18next'
import { removeUploadedDocument, getUserUploadedDocById } from '../../../api'
import { useStore } from '../../../../StateProvider'

import { isEmptyNewDocLoader } from '../../utils'
import styles from './style.css'

/**
 *
 * @param {DocMimeType} mimeType
 */
const mimeTypeToExtension = (mimeType) =>
  replace(/(image\/|application\/)/, '', mimeType)

const DocLoader = ({
  label,
  name,
  url,
  onUpload,
  onReject,
  className,
  onRemoveUploaded,
  recIndex
}) => {
  const [{
    additionalDocs,
    form: { accId }
  }] = useStore()
  const userType = accId === 0 ? 'primary' : 'joint'

  const [photo, setPhoto] = useState({})
  const [isValid, setIsValid] = useState(false)
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [uploadedId, setUploadedId] = useState()
  const { t } = useTranslation()

  useEffect(() => {
    if (additionalDocs.error && additionalDocs.error[`${userType}${recIndex}`]) {
      setError(additionalDocs.error[`${userType}${recIndex}`])
    }
  }, [additionalDocs.error])

  useEffect(() => {
    if (!isEmptyNewDocLoader(recIndex) && !uploadedId) {
      setIsLoading(true)

      getUserUploadedDocById(recIndex).then((file) => {
        setPhoto(file)
        setUploadedId(recIndex)
        setIsValid(true)
        setError('')
        setIsLoading(false)
      })
    }
  }, [])

  /**
   * @param {string} itemName
   * @param {string} message
   */
  const onDropReject = (itemName, message) => {
    if (uploadedId) {
      setIsLoading(true)

      removeUploadedDocument(uploadedId)
        .then((data) => {
          if (data.removed) {
            setIsLoading(false)

            return onReject(uploadedId, message)
          } else {
            setError('dropzone.failedToDelete')
          }

          setIsLoading(false)
        })
        .catch((error) => {
          setError(error.message)
          setIsLoading(false)
        })
    } else {
      setError(message)
    }
  }
  /**
   * @param {string} itemName
   * @param {FileImg} file
   */
  const onDropAccept = (itemName, file) => {
    const formData = new FormData()
    formData.append('documentType', 'PROOF_OF_ADDRESS')
    formData.append('extension', mimeTypeToExtension(file.type))
    formData.append('file', file)

    const resolve = (data) => {
      setPhoto(file)
      setIsValid(true)
      setIsLoading(false)
      setError('')
      setUploadedId(data.documentId)
      onUpload(data.documentId, recIndex)
    }
    /**
     * @param {ErrorCommon} rejectError
     */
    const reject = (rejectError) => {
      const error = (rejectError.message || rejectError.messageText).replace(':', '')
      setIsLoading(false)
      setError(error)
      setIsValid(false)
      setPhoto({})

      onReject(uploadedId, error)
    }

    if (uploadedId) {
      setIsLoading(true)

      removeUploadedDocument(uploadedId)
        .then((data) => {
          if (data.removed) {
            return DataProvider.postMultipart(url, formData).then(resolve, reject)
          }

          setIsLoading(false)
        })
        .catch((error) => {
          setError(error.message)
          setIsValid(false)
          setIsLoading(false)
        })
    } else {
      setIsLoading(true)
      DataProvider.postMultipart(url, formData).then(resolve, reject)
    }
  }

  const onRemoveUploadedHandler = () => {
    setIsLoading(true)
    removeUploadedDocument(uploadedId)
      .then((data) => {
        if (data.removed) {
          return onRemoveUploaded(recIndex)
        } else {
          setError('dropzone.failedToDelete')
        }

        setIsLoading(false)
      })
      .catch((error) => {
        setError(error.message)
        setIsLoading(false)
      })

    setIsLoading(false)
  }

  return (
    <div className={cn(styles.docBlock, className)}>
      <DropZone
        label={label}
        photo={photo}
        name={name}
        error={t(error)}
        valid={isValid}
        onDropReject={onDropReject}
        onDropAccept={onDropAccept}
        onRemoveUploaded={onRemoveUploadedHandler}
        isLoading={isLoading}
      />
    </div>
  )
}

export { DocLoader }
